import React, { FunctionComponent } from 'react';
import '@justgiving/users-summary/src/UsersSummary.scss';

import './MembersMini.scss';
import { useFlags } from '../../hooks';
import LeaderBoardMembersMini from './LeaderboardMembersMini';
import LegacyMembersMini from './LegacyMembersMini';

const MembersMini: FunctionComponent = () => {
  const flags = useFlags();
  return flags.useLeaderboardFundraisersListForTeams ? (
    <LeaderBoardMembersMini />
  ) : (
    <LegacyMembersMini />
  );
};

export default MembersMini;
